export const deprecate = (componentName, message) => {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  console.warn(`[Allium] [Deprecate] ${componentName}: ${message}`);
};
export const warn = (componentName, message) => {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  console.warn(`[Allium] ${componentName}: ${message}`);
};
export default {
  deprecate,
  warn
};